import { Data_getInstanceukd51bnzndrx as Data_getInstance } from './adapter/SpinMutation_ResponseAdapter.mjs';
import { getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { obj2vqjd1bjrpmyg as obj } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { Companion_getInstanceoymipm3rjnhd as Companion_getInstance } from './type/Mutation.mjs';
import { Builder320ghmibyd2no as Builder } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/CompiledGraphQL.mjs';
import { SpinMutationSelections_getInstance3ie83td9rt26x as SpinMutationSelections_getInstance } from './selections/SpinMutationSelections.mjs';
import { SpinMutation_VariablesAdapter_instanceapu1cucxe93z as SpinMutation_VariablesAdapter_instance } from './adapter/SpinMutation_VariablesAdapter.mjs';
import { Mutationkenyz0l5btz as Mutation } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Mutation.mjs';
import { ApolloAdaptableWith1g871415y7ifs as ApolloAdaptableWith } from '../../../../../../apollo-kotlin-apollo-annotations/com/apollographql/apollo/annotations/ApolloAdaptableWith.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DataClass;
function Data() {
  if (DataClass === VOID) {
    class $ {
      constructor(spin) {
        this.g6l_1 = spin;
      }
      toString() {
        return 'Data(spin=' + this.g6l_1 + ')';
      }
      hashCode() {
        return this.g6l_1 == null ? 0 : getBooleanHashCode(this.g6l_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Data()))
          return false;
        if (!(this.g6l_1 == other.g6l_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Data', VOID, VOID, VOID, VOID, VOID, {1: Data_getInstance});
    DataClass = $;
  }
  return DataClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.h6l_1 = obj(Data_getInstance());
        this.i6l_1 = (new (Builder())('data', Companion_getInstance().y6g_1)).g46(SpinMutationSelections_getInstance().l6l_1).v39();
        this.j6l_1 = '9e9620cf6c68a6bcc9b17a91bc9bb717ac303825fa49b83e7b6138072b6a4df3';
        this.k6l_1 = 'spin';
      }
      b6h() {
        return 'mutation spin($input: SpinInput!) { spin(input: $input) }';
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_0() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var SpinMutationClass;
function SpinMutation() {
  if (SpinMutationClass === VOID) {
    class $ {
      constructor(input) {
        Companion_getInstance_0();
        this.m6l_1 = input;
      }
      d6h() {
        return '9e9620cf6c68a6bcc9b17a91bc9bb717ac303825fa49b83e7b6138072b6a4df3';
      }
      operationId() {
        return this.d6h();
      }
      z49() {
        return Companion_getInstance_0().b6h();
      }
      e6h() {
        return 'spin';
      }
      operationName() {
        return this.e6h();
      }
      d49(writer, customScalarAdapters, withDefaultValues) {
        SpinMutation_VariablesAdapter_instance.n6l(writer, this, customScalarAdapters, withDefaultValues);
      }
      c49() {
        return Companion_getInstance_0().h6l_1;
      }
      toString() {
        return 'SpinMutation(input=' + this.m6l_1.toString() + ')';
      }
      hashCode() {
        return this.m6l_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SpinMutation()))
          return false;
        if (!this.m6l_1.equals(other.m6l_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SpinMutation', VOID, VOID, [Mutation()]);
    SpinMutationClass = $;
  }
  return SpinMutationClass;
}
//region block: exports
export {
  Data as Data17skrs4gatjls,
  SpinMutation as SpinMutation3rsfya4nf2aew,
};
//endregion

//# sourceMappingURL=SpinMutation.mjs.map
